'use strict';

export default function f(userModel) {
  'ngInject';

  return {
    testUser: function() {
      var testUsersIds = [
        // Audrius Tomas Paulius Linas Mantas Darius
        9501121, 9501129, 9525236, 9501128, 9501124, 9501120];
      if (testUsersIds.indexOf(userModel.item.id) !== -1) {
        return true;
      } else {
        return false;
      }
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/test_users.js